type OptionalVehicleField = {
  name: string;
  label: string;
  placeholder: string;
  type: "text" | "number";
  maxLength?: number;
  options?: { label: string; value: string | number }[];
};

export const OPTIONAL_VEHICLE_FIELDS: OptionalVehicleField[] = [
  {
    name: "totalMotorcycle",
    label: "Motosikal yang dimiliki",
    placeholder: "Bilangan Motosikal yang dimiliki",
    type: "number",
    options: Array.from({ length: 6 }, (_, value) => ({
      label: String(value),
      value,
    })),
  },
  {
    name: "totalCar",
    label: "Kereta yang dimiliki",
    placeholder: "Bilangan Kereta yang dimiliki",
    type: "number",
    options: Array.from({ length: 6 }, (_, value) => ({
      label: String(value),
      value,
    })),
  },
  {
    name: "totalElectricVehicle",
    label: "Kenderaan elektrik yang dimiliki",
    placeholder: "Bilangan kenderaan elektrik yang dimiliki",
    type: "number",
    options: Array.from({ length: 6 }, (_, value) => ({
      label: String(value),
      value,
    })),
  },
  {
    name: "registrationRemark",
    label: "Rujukan",
    placeholder: "Contoh: Ketua Kampung",
    type: "text",
    maxLength: 255,
  },
];
